import type { ComponentProps } from 'react';
import React from 'react';

import { Flex } from 'common/components/Flex';
import type { Color } from 'common/theme/colors/types';

interface FullWidthContainerProps extends ComponentProps<typeof Flex> {
  backgroundColor?: Color;
}
const containerStyles: ComponentProps<typeof Flex> = {
  width: 1,
  minWidth: 320,
  flexDirection: 'column',
};

const FullWidthContainer = ({ backgroundColor, children, ...rest }: FullWidthContainerProps) => (
  <Flex {...containerStyles} backgroundColor={backgroundColor} {...rest}>
    {children}
  </Flex>
);

export default FullWidthContainer;
